export default __webpack_public_path__ + "img/img2.f621458c.jpg";